import gql from 'graphql-tag';

export const activeLeaderboard = gql`
  mutation activeLeaderboard($input: InputUpdateLeaderboard) {
    activeLeaderboard(input: $input) {
      id
      name
      periodFrom
      periodTo
      active
    }
  }
`;
